module.exports = __webpack_public_path__ + "static/img/appback1.77cda36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/appback1.png
// module id = TXLN
// module chunks = 0